import React, { useState, useContext, useEffect } from "react";
import { motion } from "framer-motion";
import { FaEdit, FaShieldAlt, FaTrash } from "react-icons/fa";
import { Dots } from "react-activity";

// import { useNavigate } from "react-router-dom";
import UsersContext from "../Context/UsersContext";
import supabase from "../Config/Supabase";
import UserActivityChart from "../Charts/UserActivityChart";
import { BiSolidUserDetail } from "react-icons/bi";
import { IoIosWarning } from "react-icons/io";
import moment from "moment";
import { FaClock, FaIdCard, FaUser } from "react-icons/fa6";
import { HiOutlineCalendar } from "react-icons/hi2";
// import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

// Date formatter component
const formatDate = (dateString) => {
  return moment(dateString).format("MMMM D, YYYY [at] h:mm:ss A");
};

const UserProfile = () => {
  const { user } = useContext(UsersContext);
  const { users } = useContext(UsersContext);
  const [open, setOpen] = useState(false);
  const [notification, setNotification] = useState(false);
  const [value, setValue] = useState(13);

  const fuser = users?.filter((dt) => dt.id === user?.id);

  // custom functions hooks
  //   const navigate = useNavigate();
  const getRandomValue = () => {
    const randomValue = Math.floor(Math.random() * 10) + 10; // Generates a random number between 10 and 19
    setValue(randomValue);
  };

  useEffect(() => {
    getRandomValue();
  }, []);

  const handleDeleteUserAccount = () => {
    setNotification(true);
  };

  const handleDelete = () => {
    handleDeleteAccount();
  };
  // handle profileEdit
  const handleEdit = () => {
    setOpen(!open);
  };

  const handleDeleteAccount = async () => {
    const { error } = await supabase
      .from("users") // Specify your table name
      .delete() // Perform the delete operation
      .eq("id", user?.id); // Provide the condition (e.g., user with the specific id)

    if (error) {
      console.error("Error deleting user:", error.message);
    } else {
    }
  };

  if (!user)
    return (
      <div className="flex flex-col items-center justify-center min-h-screen ">
        <Dots color="#b67a3d" size={35} speed={0.7} animating={true} />
      </div>
    );
  return (
    <div className="flex flex-col min-h-screen ">
      <div className="flex flex-col w-full gap-y-10 gap-x-10">
        <div className="flex flex-col w-full">
          <img
            src={`https://picsum.photos/id/${value}/1200/800`}
            alt="Bg-picha"
            className="w-full object-cover rounded-lg md:rounded-2xl h-[14rem] md:h-[20rem] xl:h-[25rem]"
          />
          <div className="flex flex-row items-center justify-between px-2 py-5 mt-2 rounded-lg dark:text-gray-300 dark:bg-slate-900 gap-y-10 md:px-3 md:rounded-2xl bg-slate-100 md:flex-row">
            {/* User Profile */}
            <div className="flex flex-row items-center gap-x-3">
              <div className="py-3">
                <motion.img
                  className="object-cover h-12 border-4 border-green-300 rounded-full md:h-20"
                  src={`https://ui-avatars.com/api/?name=${user?.email}`}
                  alt="User Avatar"
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ duration: 0.5 }}
                />
              </div>
              <div>
                <h1 className="font-medium md:text-lg">{fuser[0]?.name}</h1>
                <p className="text-xs md:text-sm">{fuser[0]?.email}</p>
                <p className="text-xs md:text-sm">{fuser[0]?.role}</p>
              </div>
            </div>

            {/* Action buttons */}
            <div className="flex flex-col gap-y-1 md:gap-y-2">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.8 }}
                transition={{ type: "spring", ease: "easeOut" }}
                onClick={handleEdit}
                className="py-1.5 border-none text-xs md:text-sm px-2 flex flex-row items-center justify-center text-white bg-[#b67a3d] md:px-3 rounded"
              >
                <FaEdit className="" /> Edit Acc
              </motion.button>
              <motion.button
                onClick={handleDeleteUserAccount}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.8 }}
                transition={{ type: "spring", ease: "easeOut" }}
                className="flex flex-row items-center justify-center px-2 md:px-3 py-1.5 text-xs md:text-sm text-white bg-red-600 border-none rounded"
              >
                <FaTrash className="" /> Account
              </motion.button>
            </div>
          </div>
        </div>

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          {/* User Details Card */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="lg:col-span-1"
          >
            <div className="p-6 bg-white border border-gray-100 shadow-xl dark:border-gray-700 dark:bg-slate-900 rounded-2xl">
              <div className="flex items-center gap-3 mb-6">
                <div className="p-2 bg-blue-100 rounded-lg">
                  <BiSolidUserDetail className="text-xl text-blue-600" />
                </div>
                <h2 className="text-xl font-bold text-gray-900 dark:text-gray-300">
                  User Details
                </h2>
              </div>

              <div className="space-y-4">
                <div className="flex items-start gap-3 p-3 rounded-lg bg-gray-50 dark:bg-gray-800">
                  <FaIdCard className="mt-1 text-gray-500 dark:text-gray-300" />
                  <div>
                    <p className="text-sm font-medium text-gray-700 dark:text-gray-300">
                      User ID
                    </p>
                    <p className="font-mono text-sm text-gray-600 dark:text-gray-300">
                      {user?.id}
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3 p-3 rounded-lg bg-gray-50 dark:bg-gray-800">
                  <FaUser className="mt-1 text-gray-500 dark:text-gray-300" />
                  <div>
                    <p className="text-sm font-medium text-gray-700 dark:text-gray-300">
                      Full Name
                    </p>
                    <p className="text-sm text-gray-900 dark:text-gray-300">
                      {fuser[0]?.name || "Not provided"}
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3 p-3 rounded-lg bg-gray-50 dark:bg-gray-800">
                  <FaShieldAlt className="mt-1 text-gray-500 dark:text-gray-300" />
                  <div>
                    <p className="text-sm font-medium text-gray-700 dark:text-gray-300">
                      Role
                    </p>
                    <p className="text-sm text-gray-900 dark:text-gray-300">
                      {fuser[0]?.role || "User"}
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3 p-3 rounded-lg bg-gray-50 dark:bg-gray-800">
                  <HiOutlineCalendar className="mt-1 text-gray-500 dark:text-gray-300" />
                  <div>
                    <p className="text-sm font-medium text-gray-700 dark:text-gray-300">
                      Email Confirmed
                    </p>
                    <p className="text-xs text-gray-600 dark:text-gray-300">
                      {formatDate(user?.email_confirmed_at)}
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3 p-3 rounded-lg bg-gray-50 dark:bg-gray-800">
                  <FaClock className="mt-1 text-gray-500 dark:text-gray-300" />
                  <div>
                    <p className="text-sm font-medium text-gray-700 dark:text-gray-300">
                      Last Sign In
                    </p>
                    <p className="text-xs text-gray-600 dark:text-gray-300">
                      {formatDate(user?.last_sign_in_at)}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Activity Chart */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="lg:col-span-2"
          >
            <div className="p-6 bg-white border border-gray-100 shadow-xl dark:border-gray-700 dark:bg-slate-900 rounded-2xl">
              <div className="flex items-center gap-3 mb-6">
                <div className="p-2 bg-green-100 rounded-lg">
                  <FaClock className="text-xl text-green-600" />
                </div>
                <h2 className="text-xl font-bold text-gray-900 dark:text-gray-300">
                  Activity Overview
                </h2>
              </div>
              <UserActivityChart user={user} />
            </div>
          </motion.div>
        </div>

        {/* Delete Confirmation Modal */}
        {notification && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
          >
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              className="w-full max-w-md p-6 bg-white border border-gray-200 shadow-2xl dark:border-gray-700 dark:bg-slate-900 rounded-2xl"
            >
              <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 bg-red-100 rounded-full">
                <IoIosWarning className="w-8 h-8 text-red-600" />
              </div>

              <h3 className="mb-2 text-lg font-bold text-center text-gray-900 dark:text-gray-300">
                Delete Account
              </h3>

              <p className="mb-6 text-sm text-center text-gray-600 dark:text-gray-400">
                Are you sure you want to delete your account? All your data will
                be permanently removed. This action cannot be undone.
              </p>

              <div className="flex gap-3">
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={() => setNotification(false)}
                  className="flex-1 px-4 py-2 font-medium text-gray-900 transition-colors bg-gray-100 rounded-lg hover:bg-gray-200"
                >
                  Cancel
                </motion.button>
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={handleDelete}
                  className="flex-1 px-4 py-2 font-medium text-white transition-colors bg-red-600 rounded-lg hover:bg-red-700"
                >
                  Delete Account
                </motion.button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default UserProfile;
